import { ReviewRequestReducerProps } from '@core/features';
import { ReviewRequest, ReviewRequestStatus } from '@core/models';
import { useMemo } from 'react';
import { useReviewRequestState } from '..';

export type ExtendedRequests = ReviewRequestReducerProps & {
  all: ReviewRequest[];
  pendingRequests: ReviewRequest[];
  reviewedRequests: ReviewRequest[];
  draftedRequests: ReviewRequest[];
};

export const useExtendedRequests = (): ExtendedRequests => {
  const reviewRequestState = useReviewRequestState();
  const { requests } = reviewRequestState;
  const pendingRequests = useMemo<ReviewRequest[]>(
    () => requests.filter(request => request.stage === ReviewRequestStatus.Pending),
    [requests]
  );
  const reviewedRequests = useMemo<ReviewRequest[]>(
    () => requests.filter(request => request.stage === ReviewRequestStatus.Reviewed),
    [requests]
  );

  const draftedRequests = useMemo<ReviewRequest[]>(
    () => requests.filter(request => request.stage === ReviewRequestStatus.Draft),
    [requests]
  );
  return {
    ...reviewRequestState,
    all: requests,
    pendingRequests,
    reviewedRequests,
    draftedRequests,
  };
};
